import "./OilAndGasSeparation.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import Separation from "./sections/Separation";
import OilGasSolutions from "./sections/OilGasSolutions";
import TechnicalResources from "./sections/TechnicalResources";
import QuoteBand from "./sections/QuoteBand";
import Footer from "@/reusable_sections/Footer";
export default function OilAndGasSeparationPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="OilAndGasSeparation" />
      <Separation />
      <OilGasSolutions />
      <TechnicalResources />
      <QuoteBand />
      <Footer />
    </div>;
}